import { Button } from '@synergy-marine-group/synergy-ui';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useQueryClient } from 'react-query';
import Modal from 'react-responsive-modal';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import { expenseModalStyles } from './styles';

const emptyDataObj = {
  accountCodeID: '',
  expenseCategoryID: '',
  documentIdentifier: ''
};

const ExpenseFilter = ({ setModal, modal, categoryList,
  documentMappingList, accountCodeList, filterData, setFilterData, initiateFilter }) => {
  const queryClient = useQueryClient();

  const handleSubmit = (data) => {
    setFilterData(data);
    initiateFilter(data);
    setModal(false);
  };

  const handleReset = (restFormProps) => {
    setFilterData(emptyDataObj);
    restFormProps.setFieldValue('expenseCategoryID', '');
    restFormProps.setFieldValue('accountCodeID', '');
    restFormProps.setFieldValue('documentIdentifier', '');
    queryClient.invalidateQueries('getexpenseitemlist');
    setModal(false);
  };

  return (
    <Modal
    open={modal}
    onClose={() => setModal(false)}
    closeOnOverlayClick
    showCloseIcon={false}
    styles={expenseModalStyles}
    >
      <Formik initialValues={filterData} onSubmit={(values) => handleSubmit(values)}>
        {({ values, ...restFormProps }) => (
          <Form>
            <div className="w-auto input-default">
              <div className="align-middle align-center">
                <div className="grid grid-cols-2 gap-4 pb-7">
                  <Field
                    name="expenseCategoryID"
                    component={DropdownFieldComponent}
                    className="w-50"
                    options={categoryList}
                    size="large"
                    rounded
                    id="select1"
                    type="text"
                    placeholder="Category"
                    maxMenuHeight={100}
                    isClearable
                  />
                  <Field
                    name="accountCodeID"
                    component={DropdownFieldComponent}
                    className="w-50"
                    options={accountCodeList}
                    size="large"
                    rounded
                    id="select1"
                    placeholder=" Account "
                    type="text"
                    maxMenuHeight={100}
                    isClearable
                  />
                  <Field
                    name="documentIdentifier"
                    component={DropdownFieldComponent}
                    className="w-50"
                    options={documentMappingList}
                    size="large"
                    rounded
                    id="select1"
                    placeholder="Document Map.."
                    type="text"
                    maxMenuHeight={150}
                    isClearable
                  />
                </div>
                <div className="flex justify-end ">
                  <Button
                    className="max-w-none mr-4 font-montserrat text-gray-500 uppercase text-sm"
                    onClick={() => handleReset(restFormProps)}
                    size="small"
                    variant="outlined"
                    rounded
                  >
                    Reset
                  </Button>

                  <Button className="max-w-none font-montserrat text-gray-500 uppercase text-sm" size="small" variant=" filled" rounded type="submit">
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ExpenseFilter;
